'use client';

import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/solid';
import Button from '../Button';

type CarouselNavigationType = {
  items?: React.ReactNode[];
  activeIndex: number;
  onPreviousItem: () => void;
  onItemClick: (index: number) => void;
  onNextItem: () => void;
};

export default function CarouselNavigation({
  items,
  activeIndex,
  onPreviousItem,
  onItemClick,
  onNextItem,
}: CarouselNavigationType) {
  return (
    <div className="flex items-center justify-center gap-6">
      <Button
        outline
        aria-label={'Previous'}
        onClick={onPreviousItem}
        className="z-40"
        roundedFull
        variant="ghost-light"
        size="sm"
      >
        <ChevronLeftIcon className="mr-1 size-7" />
      </Button>
      <div className="hidden gap-3.5 md:flex">
        {items?.map((_, index) => (
          <button
            aria-label={`Go to slide ${index}`}
            className="group z-50 h-10 bg-transparent"
            key={`item-button-${index}`}
            onClick={() => {
              onItemClick(index);
            }}
          >
            <div
              className={`h-0.5 w-8 rounded ${
                activeIndex === index ? 'bg-white' : 'bg-gray-3'
              } group-hover:bg-gradient-to-br group-hover:from-primary group-hover:to-secondary`}
            ></div>
          </button>
        ))}
      </div>
      <Button
        variant="ghost-light"
        size="sm"
        outline
        aria-label={'Next'}
        onClick={onNextItem}
        className="z-40"
        roundedFull
      >
        <ChevronRightIcon className="ml-1 size-7" />
      </Button>
    </div>
  );
}
